// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3d9917d2] .custom-signature__extended {\n  margin-top: -40px !important;\n}\n[data-v-3d9917d2] .custom-signature__extended .tag-badge-title-info {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
